import { ShippingZoneGroupModelType } from '@teinor/erp/types/company/config/shipping/shippingZoneGroup'
import { useParams } from 'react-router-dom'
import { ComponentWithPermissions } from '../../../../../../baseComponents/CreateRoutering/types'
import DoubleTable from '../../../../../../baseComponents/DoubleTable'
import { useAddDoubleTableGreenRowRender } from '../../../../../../baseComponents/DoubleTable/functions'
import { permissionCheck } from '../../../../../../baseComponents/PermissionChecker/function'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import ModalCEConfigShippingZoneGroup from './ModalCEConfigShippingZoneGroup'
import SingleConfigShippingZone from './SingleConfigShippingZone'
import { TwinTableLink } from '../../../../../../baseComponents/TwinTable'
import BaseScreenTable from '../../../../../../baseComponents/TwinTable/BaseScreenTable'
import { TableComponentProps } from '../../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import { EditRow, DeleteRow } from '../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import ModalDeleteConfigShippingZoneGroup from './ModalDeleteConfigShippingZoneGroup'
import locations from '../../../../../../utils/globals/locations'


interface ConfigShippingZoneGroupsProps extends ComponentWithPermissions { }

const ConfigShippingZoneGroups: React.FC<ConfigShippingZoneGroupsProps> = ({ userPermissions }) => {
    const { ShippingZoneGroupId } = useParams()
    return (<DoubleTable userPermissions={userPermissions} FirstChild={ConfigShippingZonesInner} SecondChild={SingleConfigShippingZone} displaySecond={ShippingZoneGroupId !== 'main'} />)
}


interface ConfigShippingZonesInnerProps extends ComponentWithPermissions { }

const ConfigShippingZonesInner: React.FC<ConfigShippingZonesInnerProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()

    const pageData = {
        title: t('shippingZones', 'Zonas de envíos'),
        newText: t('createNewZone', 'Crear nueva zona')
    }

    return (
        <BaseScreenTable TableComponent={TableConfigShippingZoneGroup} CreateModalComponent={ModalCEConfigShippingZoneGroup} EditModalComponent={ModalCEConfigShippingZoneGroup} DeleteModalComponent={ModalDeleteConfigShippingZoneGroup} pageData={pageData} userPermissions={userPermissions} />
    )
}

interface TableConfigShippingZoneGroupProps extends TableComponentProps { }

const TableConfigShippingZoneGroup: React.FC<TableConfigShippingZoneGroupProps> = ({ setTableInstance, userPermissions, setOpened }) => {
    const { t } = useTwinTranslation()
    const { ShippingZoneGroupId } = useParams()
    const { rowRenderer } = useAddDoubleTableGreenRowRender(ShippingZoneGroupId || '')
    const columns: ColumnTableSchema<ShippingZoneGroupModelType> = [
        {
            id: 'name',
            dataKey: 'name',
            label: t('name', 'Nombre'),
            sortable: true,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('name', 'Nombre') }
            }
        },
        {
            id: 'edit',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('edit', 'Editar'),
            customRender: (parameterValue, allRowData) => <EditRow key={'edit' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData, e) => { e.preventDefault(); e.stopPropagation(); setOpened({ type: 'edit', allRowData }) }} />
        },
        {
            id: 'delete',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('delete', 'Eliminar'),
            customRender: (parameterValue, allRowData) => <DeleteRow key={'delete' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'delete', allRowData })} />,
            havePermission: permissionCheck(userPermissions, 'delete')
        }
    ]
    return (
        <TwinTableLink createRowDataLink={[locations.shippingZones, ['$id']]} columns={columns} getDataFrom='/api/app/config/shipping/shippingZone/getAllShippingZoneGroups' name='configShippingZoneGroups' setTableInstance={setTableInstance} rowRenderer={rowRenderer} hideLoadFiltersButton={true} />
    )
}

export default ConfigShippingZoneGroups